<template>
  <div>
    <div class="row">
      <div class="col-8">
        <input
          v-model="code"
          :disabled="disabled || codeValid && appliedCode"
          type="text"
          class="form-control full-width"
          placeholder="Promotional code"
          @input="codeChanged = true"
          @keyup.enter="applyCode"
        >
      </div>
      <div class="col-4">
        <button
          v-if="!codeValid || !appliedCode"
          :disabled="disabled"
          class="btn btn-default btn-block"
          @click="applyCode"
        >
          Apply
        </button>
        <button
          v-if="codeValid && appliedCode"
          :disabled="disabled"
          class="btn btn-default btn-block"
          @click="resetCode"
        >
          Reset
        </button>
      </div>
    </div>
    <div
      v-if="code != '' && !codeChanged && !codeValid && appliedCode && !pending "
      class="col-12 mt-2 text--error"
    >
      Promotion code invalid/unrecognised!
    </div>
  </div>
</template>
<script>
export default {
    name: 'BookingSummaryPromoCode',
    props: ['codeValid', 'disabled', 'pending'],
    data () {
        return {
            code: '',
            appliedCode: false,
            codeChanged: false
        }
    },
    methods: {
        applyCode: function () {
            if (!this.codeValid || !this.appliedCode) {
                this.codeChanged = false
                this.appliedCode = true
                this.$emit('codeApplied', this.code)
            }
        },
        resetCode: function () {
            this.code = ''
            this.codeChanged = false
            this.appliedCode = false
            this.$emit('codeReset')
        }
    }
}
</script>
